import clsx from 'clsx'
import find from 'lodash/find'
import map from 'lodash/map'
import React, { useContext } from 'react'
import styled from 'styled-components'

import { MetadataContext } from '@Globals/Metadata'
import { up } from '@Globals/Style/breakpoints'
import { flexCenterChildrenColumn } from '@Globals/Style/mixins'
import { useTranslation } from '@Globals/Translations'

interface WrapperProps {
  buttonActiveTextColor?: string
  buttonColor?: string
  buttonHoverColor?: string
  buttonTextColor?: string
}

const Wrapper = styled.div<WrapperProps>`
  position: relative;
  ${flexCenterChildrenColumn}
  height: 37px;
  padding: 1px 20px 0 15px;
  margin-top: 8px;
  transform: translateY(1px);

  .buttonsWrap {
    display: flex;
    margin-bottom: 1px;
    a {
      text-transform: uppercase;
      padding: 2px 5px;
      background-color: ${({ buttonColor, theme }) => buttonColor ?? theme.colors.grey};
      color: ${({ buttonTextColor, theme }) => buttonTextColor ?? theme.colors.white};
      opacity: 0.5;
      font-size: 0.75rem;
      cursor: pointer;
      &:hover {
        /* TODO: include in theme/colors system as grey darkened 30% */
        background-color: ${({ buttonHoverColor }) => buttonHoverColor ?? '#535353'};
        opacity: 0.75;
      }
      &.isActive {
        background-color: ${({ buttonActiveTextColor, theme }) => buttonActiveTextColor
            ?? theme.colors.greyDark};
        color: #fff;
        opacity: 1;
      }
    }
  }

  .toggleText {
    font-size: 0.665rem;

    ${up('desktop')} {
      font-size:0.75rem;
    }
  }
`

export const LanguageToggle = () => {
  const { t } = useTranslation()
  const { alternateLinks, availableLocales, store } = useContext(MetadataContext)

  if (!availableLocales || availableLocales.length < 2) {
    return null
  }

  return (
    <Wrapper>
      <div className="buttonsWrap">
        {map(availableLocales, ({ localeCode, title, url: localeURL }) => {
          const url = new URL(find(alternateLinks, ['locale', localeCode])?.url || localeURL)

          return (
            <a
              key={title}
              className={clsx({
                isActive: store?.config?.localeCode === localeCode,
              })}
              href={url.pathname}
            >
              {title}
            </a>
          )
        })}
      </div>
      <span className="toggleText">{t('header:SIDE_BAR_LANG_SELECT_TITLE')}</span>
    </Wrapper>
  )
}
